import { createContext } from 'react';
import { ExternalAction, ExternalData } from '../../@types/external-api';
import { Translation, UpdateTranslation } from './translations-model';

export interface TranslationsContextType {
    listTranslations: ExternalData<Translation[]>;
    listTranslationProperties: ExternalData<string[]>;
    locals: string[];
    addTranslationStatus: ExternalAction;
    updateTranslationStatus: ExternalAction;
    removeTranslationStatus: ExternalAction;
    fetchListTranslations: (locales?: string[] | string, translateFrom?: string) => void;
    fetchListTranslationProperties: (properties?:string[]) => void;
    addTranslation: (translation: Translation) => void;
    updateTranslation: (translationId: number, translation: UpdateTranslation) => void;
    removeTranslation: (translationId: number) => void;
}

const TranslationContext = createContext<TranslationsContextType>(null as any)

export default TranslationContext;
